import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import type { NotificationToggle } from './notification-toggle.types';
import { ResponsiveSectionTitle } from './responsive-section-title';
import { ToggleRows } from './toggle-rows';

export const ChatNotificationSection = ({
  isLargeUI,
  toggles,
}: {
  isLargeUI: boolean;
  toggles: NotificationToggle[];
}) => {
  const { t } = useTranslation('notifications-setting');
  return (
    <>
      <ResponsiveSectionTitle {...{ isLargeUI }}>{t('chatTitle')}</ResponsiveSectionTitle>
      <Text variant="bodyBase">{t('chatHelp')}</Text>
      <ToggleRows {...{ toggles }} />
    </>
  );
};
